import React, { useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import AdminLogin from "./pages/AdminLogin";
import AdminLayout from "./components/AdminLayout";
import Dashboard from "./pages/Dashboard";
import Contacts from "./pages/Contacts";
import ServicesPage from "./pages/ServicesPage";
import TeamPage from "./pages/TeamPage";
import TestimonialsPage from "./pages/TestimonialsPage";
import PortfolioPage from "./pages/PortfolioPage";
import About from "../components/sections/About";

export default function AdminRouter() {
  const [admin, setAdmin] = useState(() => {
    const stored = localStorage.getItem("adminUser");
    return stored ? JSON.parse(stored) : null;
  });
  const [loggingOut, setLoggingOut] = useState(false);

  const handleLogout = () => {
    setLoggingOut(true);
    setTimeout(() => {
      localStorage.removeItem("adminToken");
      localStorage.removeItem("adminUser");
      setAdmin(null);
      setLoggingOut(false);
    }, 800);
  };

  return (
    <AnimatePresence mode="wait">
      {!admin ? (
        <motion.div key="login"
          initial={{ opacity: 0, scale: 0.97 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 1.03 }}
          transition={{ duration: 0.4, ease: "easeInOut" }}>
          <AdminLogin onLogin={setAdmin} />
        </motion.div>
      ) : loggingOut ? (
        <motion.div key="logout-screen"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-[999] flex flex-col items-center justify-center"
          style={{ background: "#060b18" }}>
          <motion.div initial={{ scale: 0.8, opacity: 0 }} animate={{ scale: 1, opacity: 1 }}
            transition={{ type: "spring", stiffness: 200 }}
            className="text-center">
            <div className="w-20 h-20 gradient-bg rounded-2xl flex items-center justify-center mx-auto mb-5 shadow-2xl shadow-blue-500/30">
              <img src="/DreamGoldLogo.png" alt="logo" className="w-16 h-16 object-cover rounded-xl" />
            </div>
            <motion.div animate={{ opacity: [0.4, 1, 0.4] }} transition={{ duration: 1.2, repeat: Infinity }}>
              <p className="text-white font-bold text-lg">Logging out...</p>
              <p className="text-gray-500 text-sm mt-1">See you soon 👋</p>
            </motion.div>
            <div className="flex justify-center gap-1.5 mt-5">
              {[0, 1, 2].map((i) => (
                <motion.div key={i} className="w-2 h-2 rounded-full gradient-bg"
                  animate={{ y: [0, -8, 0] }}
                  transition={{ duration: 0.6, repeat: Infinity, delay: i * 0.15 }} />
              ))}
            </div>
          </motion.div>
        </motion.div>
      ) : (
        <motion.div key="dashboard"
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: -20 }}
          transition={{ duration: 0.4, ease: "easeInOut" }}>
          <Routes>
            <Route element={<AdminLayout onLogout={handleLogout} />}>
              <Route index element={<Navigate to="dashboard" replace />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="contacts" element={<Contacts />} />
              <Route path="services" element={<ServicesPage />} />
              <Route path="portfolio" element={<PortfolioPage />} />
              <Route path="team" element={<TeamPage />} />
              <Route path="testimonials" element={<TestimonialsPage />} />
              <Route path="about" element={<About />} />
            </Route>
          </Routes>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
